import React from 'react';
import { Carousel } from 'react-bootstrap';
import ExampleCarouselImage from './Karuselimage';
import './MyCarousel.css'; // Подключаем файл со стилями

const MyCarousel = () => {
  return (
    <div className="carousel-container">
      <h3>Only the first 2 episodes of two seasons are presented</h3>
      <span className="text-black" klm="hhh">the site is a demonstration site, for cooperation questions scroll down</span>
      <Carousel>
        <Carousel.Item>
        <ExampleCarouselImage text="First slide" />
        </Carousel.Item>
        <Carousel.Item>
          <ExampleCarouselImage text="Second slide" />
          {/* <div className="overlay-text">This is the second slide</div> */}
        </Carousel.Item>
        <Carousel.Item>
          <ExampleCarouselImage text="Third slide" />
          {/* <div className="overlay-text">This is the third slide</div> */}
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default MyCarousel;
